// Resolve a generic API base URL:
// - Prefer REACT_APP_API_BASE_URL when defined (explicit config)
// - If running on localhost/127.0.0.1 in development, use relative path '' (works with CRA proxy)
// - Otherwise, default to same-origin window.location.origin (for production deployments behind same host)
export function resolveApiBase() {
  const raw = process.env.REACT_APP_API_BASE_URL;
  const envBase = raw ? raw.replace(/\/$/, '') : '';
  const host = window.location.hostname;
  const isLocalHost = host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';

  if (envBase) {
    // If env points to loopback but app is accessed via LAN/IP, fallback to proxy to avoid 127.0.0.1 on client devices
    try {
      const u = new URL(envBase);
      const envHost = u.hostname;
  const envIsLoopback = envHost === 'localhost' || envHost === '127.0.0.1' || envHost === '0.0.0.0';
      if (!isLocalHost && envIsLoopback) {
        return '';
      }
    } catch (_) {
      // If malformed, ignore and try defaults
      return '';
    }
    return envBase;
  }

  // In development, prefer CRA proxy by using relative path regardless of host
  if (process.env.NODE_ENV === 'development') return '';
  return window.location.origin;
}
